import Cornerstone from "./Cornerstone/index.js";
import Cornerstone3D from "./Cornerstone3D/index.js";
import VTKjs from "./VTKjs/index.js";
import DICOMMicroscopyViewer from "./DICOMMicroscopyViewer/";

const adapters = {
    Cornerstone,
    Cornerstone3D,
    VTKjs,
    DICOMMicroscopyViewer
};

export default adapters;
